module.exports = __webpack_public_path__ + "img/new-un-pin.efc4554f.svg";